import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { Partner } from './partner.entity'

export class PartnersRepository extends BaseRepository<Partner> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'partners/partners', token, cache)
    }
}
